import { Button } from "@chakra-ui/react";
import { FaFilterCircleXmark } from "react-icons/fa6";
import { usePersistentGrid } from "../../hooks/usePersistentGrid";

export default function PersistentGridClearFiltersButton() {
    const { gridApi } = usePersistentGrid();

    const clearFilters = () => {
        if (!gridApi) return;
        gridApi.setFilterModel(null);
        gridApi.onFilterChanged();
    };

    return (
        <Button size="sm" variant="outline" leftIcon={<FaFilterCircleXmark />} onClick={clearFilters}>
            Clear Filters
        </Button>
    );
}
